// @ts-nocheck
import { memo } from "react";
import { Box, Button, FormLabel, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger } from "@chakra-ui/react";
import { CalendarIcon } from "@chakra-ui/icons";
import { Calendar } from "@/components/UI/Calendar";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

interface Props {
  label: string;
  date: Date | null;
  onSelect: (d: Date | null) => void;
  minDate?: Date;
  maxDate?: Date;
}

function DatePickerButtonBase({ label, date, onSelect, minDate, maxDate }: Props) {
  return (
    <Box>
      <FormLabel fontSize="sm" fontWeight="semibold" color="gray.700">{label}</FormLabel>
      <Popover>
        <PopoverTrigger>
          <Button variant="outline" w="100%" justifyContent="flex-start" leftIcon={<CalendarIcon />} fontSize="sm" fontWeight="400" _focus={{ borderColor: "black" }}>
            {date ? format(date, "dd/MM/yyyy", { locale: ptBR }) : "Selecionar data"}
          </Button>
        </PopoverTrigger>
        <PopoverContent>
          <PopoverArrow />
          <PopoverBody p={0}>
            <Calendar value={date || undefined} onSelect={onSelect} minDate={minDate} maxDate={maxDate} />
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
}

const DatePickerButton = memo(DatePickerButtonBase);
DatePickerButton.displayName = 'DatePickerButton';
export default DatePickerButton;


